import React from 'react';
import s from './styles.module.css'
import Wrapper from '../../components/wrapper';
import HeaderTitle from '../../components/header_title';

const Contact = () => {
  return (
    <div className={s.about}>
      <Wrapper>
        <HeaderTitle/>
        <form method="POST" action="/postback/cards">
        <p className={s.text}>
          <div><b>Имя</b></div>
          <div><input type="text" name="name"/></div>
        </p>
        <p className={s.text}>
          <div><b>Почта для связи</b></div>
          <div><input type="email" name="email"/></div>
        </p>
        <p className={s.text}>
          <div><b>Текст сообщания</b></div>
          <div><textarea name="text" cols="30" rows="10"/></div>
        </p>
          <button type="submit">Отправить</button>
        </form>
      </Wrapper>
    </div>
  );
};

export default Contact;
